import Vue from 'vue';
import * as utils from '../utils';
import axios from 'axios';

export default {
  name: 'Emails',
  props: {
    propEmail: {
      type: Object,
      required: true
    },
    displayRequired: {
      type: Boolean,
      default: false
    },
    fieldClass: {
      type: String,
      default: ''
    },
    phoneValidation: {
      type: Boolean,
      default: true
    },
    emailValidation: {
      type: Boolean,
      default: true
    },
  },
  data: function () {
    return {
      regExpr: '',
      displayRequiredFiledsNotification: false,
      email: {},
      message: '',
      regAcountEmailTooltip: '',
    }
  },
  computed: {
    emailValue: function () {
      return this.email.email;
    },
    emailDescr: function () {
      return this.email.descr ? this.email.descr : 'login.EmailOrPhoneNumber';
    }
  },
  watch: {
    emailValue: function (value) {
      this.message = this.validateEmail(value);
    },
  },
  async created() {
    this.displayRequiredFiledsNotification = this.displayRequired == false ? false : true;
    this.email = this.propEmail;
    this.getAcountEmailTooltip();

    this.$store.dispatch('getUtilitySettings')
      .then(resp => this.regExpr = resp.customerMobileNoRegExpr ?? '');
  },
  methods: {
    //regAcountEmailTooltip
    getAcountEmailTooltip() {
      var parameter = {
        Lang: this.$i18n.locale,
        TextId: 60
      };
      axios.post('/Utility/GetMessage', parameter)
        .then(response => {
          if (response.data.data.status == 0) {
            this.regAcountEmailTooltip = response.data.settings.text;
          }
        });
    },
    validateEmail(value) {
      if (value &&
        (this.emailValidation && !this.phoneValidation && utils.validateEmail(value)
        || !this.emailValidation && this.phoneValidation && utils.validatePhoneNumber(value, this.regExpr)
        || this.emailValidation && this.phoneValidation && utils.validateEmailPhone(value, this.regExpr) )) {               
            this.email.valid = true;
            return '';          
      }      
      else {
        this.email.valid = false;
        return this.$t('login.validEmail');
      }
    },
  },
}
